import { render, staticRenderFns } from "./CardManutencao.vue?vue&type=template&id=27caa09f&scoped=true&"
import script from "./CardManutencao.vue?vue&type=script&lang=ts&"
export * from "./CardManutencao.vue?vue&type=script&lang=ts&"
import style0 from "./CardManutencao.vue?vue&type=style&index=0&id=27caa09f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27caa09f",
  null
  
)

export default component.exports